import Vue from 'vue'
import Router from 'vue-router'
import App from './App'
import Global  from '@/scripts/Global'
import MainApi from '@/scripts/api/main.api'
import VueSignals from '@/scripts/VueSignals';

Vue.use(Router)

var alrLogginTries = 0;

const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: App
    },
    {
      path: '/channel/:id/',
      name: 'channel',
      component: App
    },
    {
      path: '/cpadmin',
      name: 'cpadmin',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CPAdmin" */ './views/components/CPAdmin.vue')
    },
    {
      path: '*login*',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Register" */ '@/components/Login.vue')
    },
    {
      path: '*register*',
      name: 'register',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Register" */ '@/components/Register.vue')
    },
    {
      path: '*confirmpassword*',
      name: 'confirmpassword',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "ConfirmPassword" */ '@/components/ConfirmPassword/ConfirmPassword.vue')
    },
    {
      path: '*contact*',
      name: 'contact',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "PublicContact" */ '@/components/PublicContact.vue')
    },
    {
      path: '*invitation*',
      name: 'invitation',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Invitation" */ '@/components/Invitation.vue')
    },
    {
      path: '*passwordforgotten*',
      name: 'passwordforgotten',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Invitation" */ '@/components/PasswordForgotten/PasswordForgotten.vue')
    },
    {
        path: '/notificationrequest',
        name: 'notificationrequest',
        component: () => import('@/components/RequestNotificationPopUp/RequestNotificationPopUp.vue')
    }

  ]
});

router.beforeEach(async (to, from, next) => {
    let alr = to.query.alr;
    // Portal can't remove chat's coockies because it is loaded in
    // an iframe
    if (alr && alrLogginTries == 0) {
        Global.Splash(1);
        Global.setAlr(alr);
        Global.removeAllCookies();
        await MainApi.authenticate('', '', alr ).then(res => {
            if(res.data.result){
                Global.globalValue(VueSignals.AUTHENTICATED, true);
                Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true);
                Global.globalValue(VueSignals.SESSION_ID, res.data.session_id);
                Global.globalValue("loggedIn", true);

                Global.setSessionID(res.data.session_id);
                MainApi.setHeader(res.data.session_id);

                alrLogginTries = 1;
                // shallow copy works because there is no function to copy
                let dir = JSON.parse(JSON.stringify(to));
                delete dir.fullPath;
                delete dir.query.alr;
                next(dir);
            }else {
                alrLogginTries = 0;
                Global.setAlr(null);
                router.push({name: 'login'});
            }
        }, (err) => {
            alrLogginTries = 0;
            next(false)
        })
    } else {
        alrLogginTries = 0;
        next();
    }
});

export default router;
